import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { SearchActionType, SearchStore } from './SearchReducer.types';

const initialStateResult = Immutable.fromJS({
  results: Immutable.List(),
  count: 0,
  next: null,
  previous: null,
  isFetching: false,
  offset: 0,
  currentPage: 0,
});

export const initialStateSearchStore = Immutable.fromJS({
  isFetching: false,
  recommendedReading: initialStateResult,
  reference: initialStateResult,
  tutorialPage: initialStateResult,
  video: initialStateResult,
  queryTerm: '',
  queryFilters: Immutable.List(),
  type: Immutable.List(),
  scrollPosition: 0,
  currentSearchPage: null,
});

const SearchReducer: any = handleActions<any>(
  {
    REQUEST_SEARCH: (state: SearchStore) => state.set('isFetching', true),
    RESPONSE_SEARCH_FAILURE: (state: SearchStore, action: SearchActionType) =>
      state
        .set('isFetching', false)
        .set('queryTerm', Immutable.fromJS(action.payload.queryTerm))
        .set('queryFilters', Immutable.fromJS(action.payload.queryFilters)),
    SEARCH_CHANGE_FILTERS: (state: SearchStore, action: SearchActionType) => state.set('queryFilters', Immutable.fromJS(action.payload)),
    SEARCH_CHANGE_DATA_QUERY: (state: SearchStore, action: SearchActionType) =>
      state.set('queryFilters', Immutable.fromJS(action.payload.queryFilters)).set('queryTerm', Immutable.fromJS(action.payload.queryTerm)),
    SEARCH_CLEAN: () => initialStateSearchStore,
    RESPONSE_SEARCH_SUCCESS: (state: SearchStore, action: SearchActionType) =>
      state.merge(
        Immutable.fromJS({
          isFetching: false,
          queryTerm: action.payload.queryTerm,
          queryFilters: action.payload.queryFilters,
          recommendedReading: state.get('recommendedReading').merge(
            Immutable.fromJS({
              ...action.payload.data.recommendedReading,
              offset: 0,
              currentPage: 0,
            })
          ),
          reference: state.get('reference').merge(
            Immutable.fromJS({
              ...action.payload.data.reference,
              offset: 0,
              currentPage: 0,
            })
          ),
          tutorialPage: state.get('tutorialPage').merge(
            Immutable.fromJS({
              ...action.payload.data.tutorialPage,
              offset: 0,
              currentPage: 0,
            })
          ),
          video: state.get('video').merge(
            Immutable.fromJS({
              ...action.payload.data.video,
              offset: 0,
              currentPage: 0,
            })
          ),
          currentSearchPage: window.location.pathname,
        })
      ),
    REQUEST_SEARCH_BY_ID: (state: SearchStore, action: SearchActionType) =>
      state.setIn([action.payload.id, 'isFetching'], true).setIn([action.payload.id, 'currentPage'], action.payload.page),
    CURRENT_SCROLL_POSITION: (state: SearchStore, action: SearchActionType) => state.set('scrollPosition', action.payload),
    RESPONSE_SEARCH_FAILURE_BY_ID: (state: SearchStore, action: SearchActionType) => state.setIn([action.payload.id, 'isFetching'], false),
    CLEAN_SEARCH_PAGE: (state: SearchStore) => state.set('currentSearchPage', window.location.pathname),
    RESPONSE_SEARCH_SUCCESS_BY_ID: (state: SearchStore, action: SearchActionType) => {
      const id = action.payload.id;

      return state.merge(
        Immutable.fromJS({
          [id]: state.get(id).merge(Immutable.fromJS({ ...action.payload.data[id], isFetching: false })),
        })
      );
    },
  },
  initialStateSearchStore
);

export default SearchReducer;
